import React from "react";
import { useSettings } from "@/contexts/SettingsContext";
import { CheckCircle2, Users, Award, TrendingUp } from "lucide-react";

export default function AboutPage() {
  const { settings } = useSettings();
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
      <div className="max-w-3xl">
        <span className="text-xs uppercase tracking-[0.25em] asg-primary font-semibold">Hakkımızda</span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold mt-3 tracking-tight" data-testid="about-title">
          Güvenin ve tecrübenin <span className="asg-primary">global</span> adresi
        </h1>
        <p className="mt-6 text-lg text-zinc-300 leading-relaxed" data-testid="about-text">
          {settings.about_text}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mt-16">
        {[
          { icon: Award, title: "Bağımsız & Objektif", desc: "20+ ana branş sigorta şirketiyle çalışıyor, hiçbir markaya bağlı kalmadan size en uygun çözümü öneriyoruz." },
          { icon: Users, title: "Uzman Kadro", desc: "Ortalama 12 yıl sektör tecrübesine sahip acente ekibimiz kişiye özel danışmanlık sağlar." },
          { icon: TrendingUp, title: "Dijital Süreçler", desc: "Poliçe teklifinden hasar dosyasına kadar tüm süreç dijital ve hızlı." },
          { icon: CheckCircle2, title: "Şeffaf Fiyatlandırma", desc: "Gizli maliyet yok. Teklif ekranında ne varsa ödemenizde de o var." },
        ].map((f) => (
          <div key={f.title} className="asg-card rounded-2xl p-8">
            <div className="h-12 w-12 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(230,32,32,0.12)" }}>
              <f.icon className="w-5 h-5 asg-primary" />
            </div>
            <h3 className="font-heading text-xl font-semibold">{f.title}</h3>
            <p className="text-zinc-400 mt-2 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 grid md:grid-cols-4 gap-6">
        {[
          { k: "40+", v: "Yıllık Tecrübe" },
          { k: "12.000+", v: "Aktif Poliçe" },
          { k: "%98", v: "Müşteri Memnuniyeti" },
          { k: "24 Saat", v: "Hasar İşlem Süresi" },
        ].map((s) => (
          <div key={s.k} className="asg-card rounded-2xl p-6">
            <div className="font-heading text-4xl font-semibold" style={{ color: "var(--asg-primary)" }}>{s.k}</div>
            <div className="text-sm text-zinc-400 mt-1 uppercase tracking-wider">{s.v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
